<template>
  <div class="row page-header-base">
    <div class="page-header-title col mx-0 mb-0 text-gray-800">
      <div :class="'page-header-title-icon bg-' + variant">
        <font-awesome-icon :icon="$t(`PAGES.${pageid}.icon`)" />
      </div>
      {{ $t(`PAGES.${pageid}.title`) }}
      <div class="page-header-title-subheading" v-if="hasSubheading">
        {{ $t(`PAGES.${pageid}.subheading`) }}
      </div>
    </div>
    <div v-if="hasButtons" class="col-4 text-right my-auto px-0 mx-0">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageid: { type: String, required: true },
    variant: { type: String, default: 'info', required: false }
  },
  computed: {
    hasSubheading () {
      return this.$t(`PAGES.${this.pageid}.subheading`)
    },
    // slot.buttonsの有無によってDomを調整
    hasButtons () {
      return !!this.$slots['buttons']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/adminparts/PageTitle.vue